module.exports = __webpack_public_path__ + "img/contract_bg3.3e115168.png";